import type { MenuAction } from './menu-actions';
import type { MenuState } from './menu-state';

export function menuReducer(state: MenuState, action: MenuAction): MenuState {
    switch (action.type) {
        case 'OPEN_MENU':
            return { ...state, open: true, highlightedIndex: -1 };

        case 'CLOSE_MENU':
            return { ...state, open: false, highlightedIndex: -1 };

        case 'SET_HIGHLIGHT':
            return { ...state, highlightedIndex: action.index };

        case 'CLEAR_HIGHLIGHT':
            return { ...state, highlightedIndex: -1 };

        case 'NAVIGATE': {
            const { direction, totalItems } = action;
            if (totalItems === 0) return state;

            const current = state.highlightedIndex;
            let next: number;

            switch (direction) {
                case 'down':
                    next = current < 0 ? 0 : (current + 1) % totalItems;
                    break;
                case 'up':
                    next = current < 0 ? totalItems - 1 : (current - 1 + totalItems) % totalItems;
                    break;
                case 'first':
                    next = 0;
                    break;
                case 'last':
                    next = totalItems - 1;
                    break;
            }

            return { ...state, highlightedIndex: next };
        }

        default:
            return state;
    }
}
